import React, { useState, useCallback, useEffect } from "react";
import { Grid, Button, Box, Typography, Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import userApi from "../../services/user";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import NewCreation from "./newCreation";
import AdjCreation from "./adjCreation";
import List from "./list";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.025)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },

    "@media (max-width: 600px)": {
      width: "100%",
      padding: "12px 4px",
      fontSize: "12px",
    },
  },
  chip: {
    marginRight: "16px",
  },
});

const Vendor = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const menuItems = useSelector((state) => state.menuReducer.items);
  const createMenuItem = menuItems?.find(
    (item) => item.name.toLowerCase() === "users"
  );
  const isDisabled = createMenuItem?.access_type === "read_write";

  const [openNewModal, setOpenNewModal] = useState(false);
  const [openAdjModal, setOpenAdjModal] = useState(false);

  return (
    <>
      <Grid item xs={12} sm={10} mb={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Inventory Sourcing</Typography>
          <Box display="flex" alignItems="center">
            {/* {isDisabled && ( */}
              <>
                <Button
                  variant="contained"
                  className={classes.animatedButton}
                  onClick={() => setOpenAdjModal(true)}
                  sx={{ marginRight: "10px" }}
                >
                  Count adjustments
                </Button>
                <Button
                  variant="contained"
                  className={classes.animatedButton}
                  onClick={() => setOpenNewModal(true)}
                >
                  Add Source
                </Button>
              </>
            {/* )} */}
          </Box>
        </Box>
      </Grid>
      <NewCreation open={openNewModal} onClose={() => setOpenNewModal(false)} />
      <AdjCreation open={openAdjModal} onClose={() => setOpenAdjModal(false)} />
      <List />
    </>
  );
};

export default Vendor;
